module.exports = __webpack_public_path__ + "img/電気回路_1_7_3.74ba97ae.jpeg";